module.exports = __webpack_public_path__ + "static/img/logo_title.a4e06bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_title.png
// module id = snWM
// module chunks = 6